export default __webpack_public_path__ + "static/media/icon_8.e8f75a4c.svg";